/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


                        app.filter('DoubleEntryFilter', function () {
                            return function (item) {
                                if (item == undefined)
                                {
                                    return []
                                }
                                ret = []

                                item.forEach(function (el) {
                                    isThere = false
                                    ret.forEach(function (el2) {
                                        if (el.email == el2.email)
                                        {
                                            isThere = true
                                        }
                                    })
                                    if (!isThere)
                                    {
                                        ret.push(el)
                                    }
                                })
                                return ret;
                            };

                        });